import { parsePath, setByPath } from "./reportPath";

const getByPath = (data: object, path: string): unknown =>
  parsePath(path).reduce<any>((value, key) => value[key], data);

// Only pending operations and rollback values live here. Report data lives in the RTK cache.
export const createOptimisticReportFields = () => {
  let nextId = 0;
  const pending = new Map<number, { path: string; value: unknown; previous: unknown }>();
  return {
    add(data: object, path: string, value: string | number | boolean | null) {
      const id = ++nextId;
      pending.set(id, { path, value, previous: getByPath(data, path) });
      setByPath(data, path, value);
      return id;
    },
    accept(data: object, id?: number) {
      if (id !== undefined) pending.delete(id);
      // The server response is already in the cache. Reapply later clicks over it.
      for (const patch of pending.values()) {
        patch.previous = getByPath(data, patch.path);
        setByPath(data, patch.path, patch.value);
      }
    },
    reject(data: object, id: number) {
      const patch = pending.get(id);
      if (!patch) return;
      pending.delete(id);
      const later = [...pending.entries()].find(([key, item]) => key > id && item.path === patch.path)?.[1];
      if (later) later.previous = patch.previous;
      else setByPath(data, patch.path, patch.previous);
    },
  };
};
